import { render, staticRenderFns } from "./RundownItem.vue?vue&type=template&id=5c21784e&"
import script from "./RundownItem.vue?vue&type=script&lang=js&"
export * from "./RundownItem.vue?vue&type=script&lang=js&"
import style0 from "./RundownItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports